module.exports = __webpack_public_path__ + "static/assets/a7d917fce3f62f17717a99e5b3db3a71.png";